<template>
  <div class="action">
    <button @click="isOpen = !isOpen" class="button is-primary" slot="botton">Create New User</button>
    <div :class="['modal', {'is-active': isOpen}]">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Create New User</p>
          <button @click="isOpen = false" class="delete" aria-label="close"></button>
        </header>
        <section class="modal-card-body">
          <form>
            <div class="field">
              <label class="modal-card-title">Name</label>
              <input
                v-model="form.name"
                @blur="$v.form.name.$touch"
                type="text"
                class="input"
                placeholder="Name"
              />
              <div v-if="$v.form.name.$error" class="form-error">
                <span v-if="!$v.form.name.required" class="help is-danger">Name is Required</span>
              </div>
            </div>
            <div class="field">
              <label class="modal-card-title">E-mail</label>
              <input
                v-model="form.email"
                @blur="$v.form.email.$touch"
                type="text"
                class="input"
                placeholder="E-mail"
              />
              <div v-if="$v.form.email.$error" class="form-error">
                <span v-if="!$v.form.email.required" class="help is-danger">E-mail is Required</span>
                <span v-if="!$v.form.email.email" class="help is-danger">Email Address is not valid</span>
              </div>
            </div>

            <div class="field">
              <label class="modal-card-title">Code No.</label>
              <input
                v-model="form.code_no"
                @blur="$v.form.code_no.$touch"
                type="text"
                class="input"
                placeholder="Code No."
              />
              <div v-if="$v.form.code_no.$error" class="form-error">
                <span v-if="!$v.form.code_no.required" class="help is-danger">Code No. is Required</span>
              </div>
            </div>

            <div class="field">
              <label class="modal-card-title">Office Code No.</label>
              <input
                v-model="form.office_code_no"
                @blur="$v.form.office_code_no.$touch"
                type="text"
                class="input"
                placeholder="Office Code No."
              />
              <div v-if="$v.form.office_code_no.$error" class="form-error">
                <span v-if="!$v.form.office_code_no.required" class="help is-danger">Code No. is Required</span>
              </div>
            </div>

            <div class="field">
              <label class="modal-card-title">Role</label>
              <!-- <input
                v-model="form.role"
                @blur="$v.form.role.$touch"
                type="text"
                class="input"
                placeholder="Code No."
              /> -->
              <p>
                <span v-if="this.$store.state.auth.user.role == '0'" >
                     <input class="radio" type="radio" v-model="form.role" @blur="$v.form.role.$touch" value=0>Super Admin
                    <span style="margin-right:40px;"></span>
                </span>
                    <input class="radio" type="radio" v-model="form.role" @blur="$v.form.role.$touch" value=1>Admin
                    <span style="margin-right:30px;"></span>
                    <input class="radio" type="radio" v-model="form.role" @blur="$v.form.role.$touch" value=4>Analytics
                    <span style="margin-right:30px;"></span>
                    <input class="radio" type="radio" v-model="form.role" @blur="$v.form.role.$touch" value=2 >Data Admin
                    <span style="margin-right:30px;"></span>
                    <input class="radio" type="radio" v-model="form.role" @blur="$v.form.role.$touch" value=3 checked="checked">Data Clerk
                    
            </p>
              <div v-if="$v.form.role.$error" class="form-error">
                <span v-if="!$v.form.role.required" class="help is-danger">Role is Required</span>
              </div>
            </div>

            <div class="field">
              <label class="modal-card-title">Designation</label>
              <input
                v-model="form.designation"
                @blur="$v.form.designation.$touch"
                type="text"
                class="input"
                placeholder="Designation"
              />
              <div v-if="$v.form.designation.$error" class="form-error">
                <span v-if="!$v.form.designation.required" class="help is-danger">Designation is Required</span>
              </div>
            </div>

            <div class="field">
              <label class="modal-card-title">Contact Number</label>
              <input
                v-model="form.contact_number"
                @blur="$v.form.contact_number.$touch"
                type="text"
                class="input"
                placeholder="Contact No."
                @keypress="isLetterOrNumber($event)"
              />
              <div v-if="$v.form.contact_number.$error" class="form-error">
                <span v-if="!$v.form.contact_number.required" class="help is-danger">Contact No. is Required</span>
              </div>
            </div>
            

            <div class="field">
              <label class="modal-card-title">Password</label>
              <input
                v-model="form.password"
                class="input"
                @blur="$v.form.password.$touch"
                type="password"
              />
              <div v-if="$v.form.password.$error" class="form-error">
                <span v-if="!$v.form.password.required" class="help is-danger">Password is Required</span>
                <span
                  v-if="!$v.form.password.minLength"
                  class="help is-danger"
                >Password Minimum length is 6 characters</span>
              </div>
            </div>
            <div class="field">
              <label class="modal-card-title">Confirm Password</label>
              <input
                v-model="form.passwordConfirm"
                @blur="$v.form.passwordConfirm.$touch"
                type="password"
                class="input"
              />
              <div v-if="$v.form.passwordConfirm.$error" class="form-error">
                <span
                  v-if="!$v.form.passwordConfirm.required"
                  class="help is-danger"
                >Password Confirmation is Required</span>
                <span
                  v-if="!$v.form.passwordConfirm.sameAs"
                  class="help is-danger"
                >Password and Confirm Password are not the same</span>
              </div>
            </div>
            <!-- <div class="field">
              <label class="modal-card-title m-b-sm">Please Choose User Role</label>
              <div class="control">
                <div class="select is-primary">
                  <select v-model="form.role">
                    <option>user</option>
                    <option>manager</option>
                    <option>admin</option>
                    <option>question-manager</option>
                  </select>
                </div>
                <div v-if="form.photoUrl" class="container">
                  <img class="avatar" :src="form.photoUrl" alt />
                </div>
              </div>
            </div> -->
            <!-- <b-field class="field">
              <b-upload v-model="file" @input="upload" accept="image/*">
                <a class="button is-primary">
                  <b-icon icon="upload" custom-size="default"></b-icon>
                  <span>{{ buttonLabel }}</span>
                </a>
              </b-upload>
            </b-field> -->
            <!-- <progress
              v-if="uploadPercent > 0"
              class="progress is-primary"
              :value="uploadPercent"
              max="100"
            >{{uploadPercent}}%</progress> -->
          </form>
        </section>
        <footer class="modal-card-foot">
          <button
            @click="createUserPressed"
            :disabled="isFormInvalid || this.oneOfCodes"
            class="button is-success"
          >Save changes</button>
          <button @click="isOpen = false" class="button">Cancel</button>
        </footer>
      </div>
    </div>
  </div>
</template>



<script>
import axiosInstance from '../../services/axios';
import { getAPIEndpoint } from '../../helpers';
import {
  required,
  email,
  code_no,
  office_code_no,
  minLength,
  url,
  sameAs,
} from 'vuelidate/lib/validators';
export default {
  data() {
    return {
      isOpen: false,
      form: {
        name: '',
        email: '',
        code_no: '',
        office_code_no: '',
        role:'',
        password: '',
        passwordConfirm: '',
        designation: '',
        contact_number: '',
      },
    };
  },
  validations: {
    form: {
      name: {
        required,
      },
      email: {
        required,
        email,
      },
      code_no: {
        // required,
      },
      office_code_no: {
        // required,
      },
      role: {
        required,
      },
      designation: {
        // required,
      },
      contact_number: {
        // required,
      },
      password: {
        required,
        minLength: minLength(6),
      },
      passwordConfirm: {
        required,
        sameAsPassword: sameAs('password'),
      },
    },
  },
  computed: {
    isFormInvalid() {
      return this.$v.form.$invalid;
    },
    oneOfCodes(){
    if( (this.form.code_no !== '' ) || 
        (this.form.office_code_no !== '' )){
          return false;
        }
        else{
          return true;
        }
  }
    // buttonLabel() {
    //   return !this.file ? 'Pick a file' : 'Pick another file';
    // },
  },
  // props: {
  //     authUser: {
  //         type: Object,
  //         required: true
  //     }
  // },
  // methods: {
  //     emitUser () {
  //         this.$emit('userSubmitted', {user: this.user, done: () => this.isOpen = false})
  //     }
  // }
  methods: {
    isLetterOrNumber(e) {
            let char = String.fromCharCode(e.keyCode);
            if (/^[0-9]+$/.test(char)) return true;
            else e.preventDefault();
        },
    createUserPressed() {
      // console.log(this.form);
      this.$v.form.$touch();

      if (!this.form.photoUrl) {
        delete this.form.photoUrl;
      }

      this.$store
        .dispatch('users/createUser', this.form)
        .then(() => {
          this.isOpen = false;

          this.form = {};
          this.uploadPercent = 0;

          this.$buefy.snackbar.open({
            message: 'User Created Successfully',
            queue: false,
          });
        })
        .catch((err) => {
          this.$buefy.snackbar.open({
            message: `${err.response.data.message}`,
            queue: false,
          });
        });
    },
    upload(file) {
      this.$emit('input', file);

      this.uploadPercent = 0;

      let formData = new FormData();

      formData.append('image', file);

      axiosInstance
        .post(`${getAPIEndpoint()}/auth/image-upload`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: this.progressEvent,
        })
        .then((res) => {
          this.form.photoUrl = res.data.imageUrl;
        })
        .catch((err) => {
          this.$buefy.toast.open({
            message: `Error: ${err.message}`,
            type: 'is-danger',
          });
        });
    },
    progressEvent(progressEvent) {
      this.uploadPercent = Math.round(
        (progressEvent.loaded * 100) / progressEvent.total
      );
    },
  },
};
</script>


<style scoped>
.modal-card {
  width: auto;
}

.container {
  width: 50px;
  margin: 0 80%;
}

.level .img {
  right: -112px;
  position: absolute;
  border-radius: 30px;
}
</style>



